import { useRef, FC, RefObject } from "react";
import { Button } from "@tennr/frontend/components/Button/Button";
import { ShadowInfoCard } from "@tennr/frontend/components/ShadowInfoCard";
import { CaseStudyCopy } from "@tennr/frontend/components/CaseStudyCopy";
import { Card } from "@tennr/frontend/components/Card";
import { useNavigate } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";
import "./CaseStudiesSection.css";

export interface CaseStudiesSectionProps {
  onRefReady?: (ref: RefObject<HTMLDivElement>) => void;
}

export const CaseStudiesSection: FC<CaseStudiesSectionProps> = ({ onRefReady }) => {
  const navigate = useNavigate();

  // provide access to the ref for parent components if needed
  const taglineCardRef = useRef<HTMLDivElement>(null!);
  if (onRefReady) {
    onRefReady(taglineCardRef);
  }

  return (
    <section className="case-studies section-y">
      <div className="case-studies-container">        
        <CaseStudyCopy />
        <div className="case-study-cards">
          <Link to="/customer-stories/homemedix" style={{ textDecoration: "none" }}>
            <ShadowInfoCard
              body="Processing referrals 75% faster than before with 4x the volume"
              image={"/img/homemedix-3.png"}
              imageAlt="HomeMedix"
            />
          </Link>
          <Link to="/customer-stories/eastern-medtech" style={{ textDecoration: "none" }}>
            <ShadowInfoCard
              body="Growing new product lines thanks to automated intake "
              image={"/img/easternmedtech-2.png"}
              imageAlt="Eastern MedTech"
            />
          </Link>
          <Link to="/customer-stories/neb-medical-services" style={{ textDecoration: "none" }}>
            <ShadowInfoCard
              body="From a 3-week backlog to same-day patient intake"
              image="/img/neb-medical-2.png"
              imageAlt="Neb Medical Services"
            />
          </Link>
        </div>
        <Button
          minWidth="300px"
          className="left-offset-button"
          // minHeight="62px"
          text="EVEN MORE CASE STUDIES"
          onClick={() => navigate({ to: "/studies" })}
        />
      </div>
      <div ref={taglineCardRef} />
    </section>
  );
};
